import React from "react";
import { Skeleton, Box, Card } from "@mui/material";

function TimelineSkeleton() {
    return (
        <Box display="flex" mb={3} pl={{xxs: 0.25, sm: 1.25}} pr={1.25}>
            {/* Date Column Placeholder (Hidden on Mobile) */}
            <Box display={{ xxs: 'none', sm: 'flex' }} flexDirection="column" alignItems="center" px={1}>
                <Skeleton variant="text" width={30} height={40} />
                <Skeleton variant="text" width={25} height={20} />
            </Box>

            {/* Main Card Placeholder */}
            <Box flex={1} display="flex" position="relative">
                {/* Timeline Dot Skeleton */}
                <Box zIndex={2} sx={{ pl: { xxs: 0, sm: 1.5 }, pr: { xxs: 1, sm: 1.5 }, pt: 2.5 }}>
                    <Skeleton variant="circular" width={26} height={26} />
                </Box>

                <Card sx={{ padding: 2, borderRadius: '6px', border: '1px solid #e9e9e9', boxShadow: 'none', width: '100%' }}>
                    {/* Top Section */}
                    <Box display="flex" justifyContent="space-between" mb={2}>
                        <Skeleton variant="text" width="40%" height={30} />
                        <Box display="flex" gap={1}>
                            <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: '8px' }} />
                            <Skeleton variant="rectangular" width={40} height={24} sx={{ borderRadius: '8px' }} />
                        </Box>
                    </Box>

                    {/* Middle Section */}
                    <Box display="flex" justifyContent={'space-evenly'} gap={2} mb={2}>
                        <Skeleton variant="text" width="30%" height={20} />
                        <Skeleton variant="text" width="30%" height={20} />
                        <Skeleton variant="text" width="30%" height={20} />
                    </Box>

                    <Skeleton variant="rectangular" width="100%" height={1} sx={{ my: 2 }} />

                    {/* Bottom Section */}
                    <Box display="flex" justifyContent="space-between">
                        <Skeleton variant="text" width="20%" height={20} />
                        <Skeleton variant="rectangular" width={100} height={32} sx={{ borderRadius: '4px' }} />
                    </Box>
                </Card>
            </Box>
        </Box>
    );
}

export default TimelineSkeleton;